import { render, staticRenderFns } from "./Acquirers.vue?vue&type=template&id=70d17cd2&scoped=true&"
import script from "./Acquirers.vue?vue&type=script&lang=ts&"
export * from "./Acquirers.vue?vue&type=script&lang=ts&"
import style0 from "./Acquirers.vue?vue&type=style&index=0&id=70d17cd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d17cd2",
  null
  
)

export default component.exports